<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-4">
        <app-breadcrumb
          :page-title="title"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-8 breadcrumb-side-button" v-if="hideBtn == true">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>
          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('create_document_library_action')">
             <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              data-toggle="modal"
              @click="createForm">
              {{ $t("create_form") }}
            </button>
          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('create_document_library_folder_action')">
             <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              data-toggle="modal"
              @click="CreateEditFolderModal">
              {{ $t("create_folder") }}
            </button>
          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('form_theme_instruction')">
             <button
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              @click="openFormThemeModal">
              {{ $t("form_theme") }}
            </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{type == 'questionnaire' ? $t("instructions_about_my_questionnaire") : $t("instructions_about_my_document_library") }}</h5>
          <p class="mb-0">{{type == 'questionnaire' ? $t("introduction_my_questionnaire") : $t("introduction_my_document")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("edit") }} :</strong> {{ $t("edit_myform_action") }}</li>
            <li><strong>{{ $t("delete") }} :</strong> {{ $t("delete_myform_action") }}</li>
            <li><strong>{{ $t("form_builder") }} :</strong> {{ $t("form_builder_action") }}</li>


          </ul>
        </div>
      </div>
    </div>
    <div v-if="active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="active < 5"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
        <el-breadcrumb-item><a href="" v-if="active == 3 || active == 4" @click.prevent="createForm">Create Form</a> <span v-else>Create Form</span></el-breadcrumb-item>
        <el-breadcrumb-item v-if="active == 3">Set Form Information</el-breadcrumb-item>
        <el-breadcrumb-item v-if="active == 4">Import Form</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form v-if="active === 1">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-8">
          <div class="form-group align-items-center my-filter">
            <label for="filter_category">
              {{ $t("filter_category") }}
            </label>
            <app-input
              type="multi-select"
              :list="category"
              :isAnimatedDropdown="true"
              :required="true"
              placeholder="Select Category"
              v-model="category_id"
            />
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="form-group align-items-center my-filter">
            <label for="search_form">
              {{ $t("search_form") }}
            </label>
            <app-input
                type="text"
                placeholder="Input form title"
                v-model="searchText"
                @input="handleInput" @keyup.enter="search"
            />
            <!-- Button to trigger search -->
            <button class="btn btn-sm btn-info" @click.prevent="loadDocuments">Search</button>
          </div>
        </div>
      </div>
      <div class="card card-folders">
        <div class="card-header">
          <app-overlay-loader v-if="preloader" />
          <div class="row align-items-center">
              <div class="col mr-auto">
                <h4 class="card-title m-0 text-white">User Folders</h4>
              </div>
              <div class="mt-auto mr-3">
                <button class="btn btn-sm btn-success" @click.prevent="openDocumentControl">Document Control Register</button>
              </div>
              <div class="mt-auto">
                <button @click.prevent="openFormLogModal" class="btn btn-sm btn-danger">View Library Updates ({{ unreadFormLogCount }})</button>
              </div>
              <!-- <div class="col col-auto pr-2">
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-secondary" id="btn-list" @click.prevent="list"><i class="fa fa-th-list fa-lg"></i></button>
                  <button class="btn btn-sm btn-outline-secondary outline-none active" id="btn-grid" @click.prevent="grid"><i class="fa fa-th-large fa-lg"></i></button>
                </div>
              </div> -->
            </div>
        </div>

        <div class="card-body" id="foldersGroup">
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item active"><i class="far fa-folder"></i>&nbsp; Folders</li> -->
          </ol>
          <div id="main-folders" class="d-flex align-items-stretch flex-wrap flex-column">
            <div class="d-inline-flex tree-menu-parent" id="tree-menu-parent">
              <tree-menu 
                      :label="tree.label" 
                      :nodes="tree.nodes"
                      :category_name="tree.nodes.category_name"
                      :depth="0"
                      :owner_id="tree.nodes.owner_id"
                      :form_id="tree.nodes.id"
                      :type="type"
                      :myForm="myForm"
                      :refresh="loadDocuments"
                      :updated_at="tree.nodes.updated_at"
                      :expanded="depth === 0"
                    >
              </tree-menu>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <el-form v-if="active === 2">
      <h1 class="text-center">Create a Form</h1>
      <p class="text-center">Create an amazing form to collect data easily</p>

      <div class="container">
        <div class="row d-flex justify-content-center">
          <div class="col-md-3 courser-style"  @click.prevent="setFormInfo">
            <div class="d-flex justify-content-center card01">
            <i class="fa fa-plus fa-4x icon" aria-hidden="true"></i>
            </div>
            <h4 class="text-center">Start From Scratch</h4>
            <p class="text-center">A blank slate is all you need</p>
          </div>
          <div class="col-md-3 courser-style" @click.prevent="importForm">
            <div class="d-flex justify-content-center card01">
            <i class="fas fa-file fa-5x icon" style="color:#fff"></i>
            </div>
            <h4 class="text-center">Use Template</h4>
            <p class="text-center">Choose from 10,000+ premade forms</p>
          </div>
          <!-- <div class="col-md-3 courser-style"  @click.prevent="importForm">
            <div class="d-flex justify-content-center card01">
            <i class="fa fa-sign-out fa-4x icon" aria-hidden="true"></i>
            </div>
            <h4 class="text-center">Existing Form</h4>
            <p class="text-center">Select an Existing Form</p>
          </div> -->
        </div>
        
      </div>
    </el-form>
    <el-form v-if="active === 3">
      <documentlibrary-add-forminformation @view="view" :back="createForm" :type="type"></documentlibrary-add-forminformation>
    </el-form>

    <el-form v-if="active === 4">
      <documentlibrary-index :remove="classRemove" :importFlag="true" :is_use_template="true"></documentlibrary-index>
    </el-form>

    <documentlibrary-addmodal
      v-if="isAddEditModalActive"
      :refresh="loadDocuments"
      :type="type"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <documentlibrary-AddUpdateFolderModal
      v-if="isAddEditFolderModalActive"
      :refresh="loadDocuments"
      :type="type"
      :selected-url="selectedUrl"
      :selected-id ="selectedId"
      @close-modal="closeAddEditFolderModal"
    />

    <form-log-modal
      v-if="isFormLogModalActive"
      :type="loadFromType"
      @close-modal="closeFormLogModal"
    />

    <app-formBuilder-modal
      v-if="formBuilderModalActive"
      :id="id"
      :type="type"
      :myForm="myForm"
      :table-id="tableId"
      @close-modal="closeFormBuilderModal"
    />

    <app-document-child-list-modal
      v-if="documentChildListModalActive"
      :id="id"
      :type="type"
      :myForm="myForm"
      :table-id="tableId"
      @close-modal="closeFormBuilderModal"
    />

    <documentlibrary-form-theme-modal
      v-if="isFormThemeModalActive"
      @close-modal="closestFormThemeModal"
    />
  </div>
</template>

<script>

import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import TreeMenu from './TreeMenu.vue'
import OverlayLoader from "@/core/components/preloders/OverlayLoader";
import {createListTree, loadDocuments, unFlatten} from "@Views/CustomFormBuilder/utilities/formsDirectory";

export default {
  extends: CoreLibrary,
  name: "MyDocumentDirectory",
  mixins: [TableHelpers,FormMixin],
  components: {
    TreeMenu, OverlayLoader
  },
  data() {
    return {
      tree : {
        label: 'Click to Expand',
        nodes: [

        ],
        expanded: true
      },
      depth: 0,
      loadFromType: '',
      formUrl: '',
      category_id: 0,
      classRemove: true,
      active: 1,
      hideBtn: true,
      instructionShow: false,
      documents: [],
      children: [],
      preloader: true,
      category: [],
      type:'',
      title:'',
      id: 0,
      myForm: '',
      parentEl:[],
      childEl: [],
      isAddEditModalActive: false,
      isFormLogModalActive: false,
      isAddEditFolderModalActive: false,
      formBuilderModalActive: false,
      documentChildListModalActive: false,
      isFormThemeModalActive: false,
      selectedId: "",
      perPage: 3,
      currentPage: 1,
      links: [],
      next_page_url: '',
      prev_page_url: '',
      unreadFormLogCount: 0,
      searchText:'',
    };
  },
  watch: {
    // templateForm(newValue, oldValue) {
    //   // Perform actions when templateForm changes
    //   this.active = 3
    //   console.log('Template form changed: ', newValue);
    // },
    category_id() {
      this.filterByCategory();
    },
  },
  created() {
    this.autoloadFormChanges();
  },
  methods: {
    // templateForm(){
    //   return this.$store.state.sharedData.sharedData.templateForm;
    // },
    handleInput() {
      // Handle input change, e.g., show suggestions, etc.
      if (this.searchText.length >= 4) {
        // Optionally, you can trigger a function here
        this.loadDocuments();
        }
      },
    filterByCategory() {
      this.loadDocuments(this.category_id);
      // console.log(this.category_id);
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    
    openAddEditModal() {
      this.selectedUrl = "";
      this.isAddEditModalActive = true;
    },
    CreateEditFolderModal() {
      // this.selectedUrl = "";
      this.selectedId = "";
      this.isAddEditFolderModalActive = true;
    },

    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
    },
    closeAddEditFolderModal() {
      $("#demo-add-edit-folder-Modal").modal("hide");
        this.isAddEditFolderModalActive = false;
    },

    openFormLogModal() {
      this.isFormLogModalActive = true;
    },
    closeFormLogModal() {
      $("#demo-form-log-Modal").modal("hide");
      this.isFormLogModalActive = false;
    },
    
    openFormThemeModal() {
      this.isFormThemeModalActive = true;
    },
    closestFormThemeModal() {
      $("#demo-form-theme-Modal").modal("hide");
      this.isFormThemeModalActive = false;
    },
    openFormBuilderModal() {
      this.formBuilderModalActive = true;
    },
    openListModal() {
      this.documentChildListModalActive = true;
    },
    closeFormBuilderModal() {
      this.previous();
      $("#form-builder-Modal").modal("hide");
      this.formBuilderModalActive = false;
    },

    setFormType()
    {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let type = split[5].split("?")[0];
      if (type == 'myquestionnaire' || type == 'mytraining') {
        let form_type = type == 'mytraining' ? 'training' : 'questionnaire';
        this.formUrl = actions.MY_DOCUMENT_FORMS+'?form_type='+form_type+'&';
        this.title = this.$t(type == 'mytraining' ? 'training_modules' : 'my_questionnaire');
        this.type = form_type;
        this.myForm = 'my_form';
      }
      else
      {
         this.formUrl = actions.MY_DOCUMENT_FORMS+'?';
         this.title =  this.$t('my_document');
         this.myForm = 'my_form';
      }
      const urlParams = new URLSearchParams(window.location.search);
      this.searchText = urlParams.get('searchText');
      
    },
    createForm() {
      this.title = 'Create Form';
      this.hideBtn = false;
      this.instructionShow = false;
      this.active = 2;
    },
    setFormInfo() {
      this.active = 3;
    },
    importForm() {
      this.title = 'Import Form';
      this.active = 4;
    },
    previous() {
      this.setFormType();
      this.loadDocuments();
      this.getCategories();
      this.hideBtn = true;
      this.instructionShow = false;
      this.active = 1;
      // this.list();
    },

   loadDocuments,
    paginate(url){
      let url_split = url.split('/admin').pop();
      this.axiosGet('admin/'+url_split)
        .then((res) => {    
            this.documents = res.data.data;
            this.links = res.data.links;
            this.next_page_url = res.next_page_url;
            this.prev_page_url = res.prev_page_url;
            this.preloader = false;
        })
        .catch((res) => {
          
        })
        .finally(() => {
        });
    },
    createFolder(id){
      if(id){
          this.selectedId = id;
          this.selectedUrl = "";
          this.isAddEditFolderModalActive = true;
        }else{
            this.$toastr.s('Could not create folder');
        }
    },
    openSubList(id){
      let data = this.unFlatten(this.children)
      this.tree = {...this.tree, nodes : data};

    },

    unFlatten,
    createListTree,
    getCategories() {
      this.axiosGet(actions.CATEGORIES)
        .then((res) => {
          this.category = res.data;
          // console.log(this.category);
        })
        .catch((error) => {
          
        });
    },
    view(id) {
        this.id = id;
        this.openFormBuilderModal();
    },
    autoloadFormChanges() {
        let myLocation = location.href;
        let split = myLocation.split("/");
        let type = split[5].split("?")[0];
        if (type == 'myquestionnaire') {
          this.loadFromType ='questionnaire';
        } else if (type == 'mytraining') {
          this.loadFromType ='training';
        }
        else
        {
          this.loadFromType ='document';
        }
        this.axiosGet(actions.FORM_CHANGES_AUTOLOAD+'/'+this.loadFromType)
        .then((res) => {
          if (res.data.count > 0) {
            this.unreadFormLogCount = res.data.count;
            this.openFormLogModal();
          }
        })
        .catch((error) => {
          
        });
      },
      openDocumentControl() {
        window.location = '/document-control-register';
      }
  },
  mounted() {

    this.preloader = true;
    this.setFormType();
    this.loadDocuments();
    // this.list();
    this.getCategories();
    this.preloader = false;

  },
  computed: {
    // templateForm() {
    //   return this.templateForm(); // Returns the computed getter
    // },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    themeMode() {
      return this.$store.state.theme;
    },
    
  }
};
</script>

<style>

.card01{
  /* box-shadow:10px 10px 5px -6px rgba(8,96,95,0.75) !important; */
  background-color:#292F4C;
  height:200px;
  border-radius: 25px;
  margin: 10px;
}
.icon{
  align-self: center;
  color:#fff;
}
.courser-style {
  cursor: pointer;
}
.div-table {

}
.div-table-head{
  font-weight: 600;
}
.div-table-row {
  display: flex;
  justify-content: space-between;
  width: auto;
  clear: both;
  cursor: pointer;
  padding:  5px;
}
.div-table-row:hover {
  background-color: #efefef;
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;         
  width: 200px;         
  height: 30px;
}
.children{
  margin-left: 30px;
}
.action-col{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* filter styling */
.my-filter .chips-container {
  background: #f5dddd !important;
  color: #000 !important;
}
</style>
